<template>

  <li class="single-tab" ref="tab" @click="selectTab()">
   
      <i :class="icon"> </i>
      <span class="navigation-name"> <slot v-if="this.$parent.shouldExpand == true"> </slot>  </span>

  </li>

</template>

<script>
export default {
 props: {
    icon: {
      type: String,
      default: 'tab'
    }
  },
  data(){
    return{
        shouldExpand: false
    }
  },
  methods:{

      selectTab(){

        for(var i = 0; i < this.$parent.$children.length; i++){
        this.$parent.$children[i].$el.classList.remove("selected")
        }
        
        this.$el.classList.add("selected");
      }
  },
}
</script>

<style scoped>

li{
    color: #A4A6B4;
    padding: 20px;
    white-space: nowrap;
    border-left: 4px solid transparent;
    cursor: pointer;
}
li:hover{
  background-color: #333544;
}
.selected{
    font-weight: bold;
    color: #0092FF;
    border-left: 4px solid;
}

.navigation-name{
      margin-left: 5px;
 }
</style>